"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPaymentListApi = getPaymentListApi;
exports.getPaymentStatsApi = getPaymentStatsApi;
exports.getSupplierInfoApi = getSupplierInfoApi;
exports.getSupplierQrcodeApi = getSupplierQrcodeApi;
exports.updateSupplierInfoApi = updateSupplierInfoApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 获取当前供应商信息
 */
function getSupplierInfoApi() {
  return (0, _request.default)({
    url: 'supplier/info',
    method: 'get'
  });
}

/**
 * 更新当前供应商信息（折扣率等）
 */
function updateSupplierInfoApi(data) {
  return (0, _request.default)({
    url: 'supplier/update',
    method: 'post',
    data: data
  });
}

/**
 * 获取供应商码（小程序二维码）
 */
function getSupplierQrcodeApi() {
  return (0, _request.default)({
    url: 'supplier/qrcode',
    method: 'get'
  });
}

/**
 * 扫码收款记录列表
 */
function getPaymentListApi(params) {
  return (0, _request.default)({
    url: 'supplier/payment/list',
    method: 'get',
    params: params
  });
}

/**
 * 扫码收款统计
 */
function getPaymentStatsApi() {
  return (0, _request.default)({
    url: 'supplier/payment/stats',
    method: 'get'
  });
}